// highlight.js  代码高亮指令
import Vue from 'vue';
import Hljs from 'highlight.js';
import 'highlight.js/styles/agate.css';

// 先有数据再绑定，调用highlight
Vue.directive('highlight', {
  inserted(el, binding) {
    el.style.maxHeight = binding.value ? binding.value.height : '400px';
    el.style.height = 'auto';
    el.style.overflowY = 'auto';
    const blocks = el.querySelectorAll('pre code');
    for (let i = 0; i < blocks.length; i += 1) {
      const item = blocks[i];
      Hljs.highlightBlock(item);
    }
  },
});
// 先绑定，后面会有数据更新，调用highlightUpdated
Vue.directive('highlightUpdated', {
  componentUpdated(el, binding) {
    el.style.maxHeight = binding.value ? binding.value.height : '400px';
    el.style.height = 'auto';
    el.style.overflowY = 'auto';
    const blocks = el.querySelectorAll('pre code');
    for (let i = 0; i < blocks.length; i += 1) {
      const item = blocks[i];
      Hljs.highlightBlock(item);
    }
  },
});
